import { Navigate, Route, Routes } from "react-router-dom";

import { RequireLoggedOut, ROUTES } from "@/app/router";
import { Account, ScheduleAppointment, SuccessScreen } from "../screens";
import {
  RequireEmbeddablesHealthieAccount,
  RequireValidUserCode,
} from "./components";
import { EMBEDDABLES_ROUTE } from "./constants";

const getPartialRoute = (route: string) => {
  return route.replace(EMBEDDABLES_ROUTE.BASE, "");
};

export const EmbeddablesRouter = () => {
  return (
    <Routes>
      <Route
        path={`${getPartialRoute(EMBEDDABLES_ROUTE.ACCOUNT)}/:userCode`}
        element={
          <RequireLoggedOut>
            <RequireValidUserCode>
              <Account />
            </RequireValidUserCode>
          </RequireLoggedOut>
        }
      />

      <Route element={<RequireEmbeddablesHealthieAccount />}>
        <Route
          path={getPartialRoute(EMBEDDABLES_ROUTE.SCHEDULE_APPOINTMENT)}
          element={<ScheduleAppointment />}
        />
      </Route>

      <Route
        path={getPartialRoute(EMBEDDABLES_ROUTE.SUCCESS)}
        element={<SuccessScreen />}
      />

      <Route path="*" element={<Navigate replace to={ROUTES.BASE} />} />
    </Routes>
  );
};
